"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScreenMode = void 0;
var ScreenMode;
(function (ScreenMode) {
    ScreenMode[ScreenMode["Screen"] = 0] = "Screen";
    ScreenMode[ScreenMode["Dialog"] = 1] = "Dialog";
})(ScreenMode = exports.ScreenMode || (exports.ScreenMode = {}));
//# sourceMappingURL=ScreenMode.js.map